import { Component, OnInit, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { animate, state, style, transition, trigger, } from '@angular/animations';
import { Location, LocationStrategy, PathLocationStrategy, } from '@angular/common';
import { StoreService } from '../store.service';
import { UtilitiesService } from '../core/utilities.service';
import { TranslationService } from '../core/translation.service';
import { environment } from 'src/environments/environment';
import { DataService } from '../data.service';
import { DashboardCreateStoreComponent } from './create-store/create-store.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DEALER_STATUS } from 'src/app/core/constants/data.constant';
import { DealerService } from 'src/app/dealer.service';
import { StoreInfoService } from 'src/app/store-info.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  animations: [
    trigger('collapse', [
      state(
        'true',
        style({
          transform: 'translate3d(0,0,0)',
        })
      ),
      state(
        'false',
        style({
          transform: 'translate3d(-100%, 0, 0)',
        })
      ),
      transition('true => false', animate('0ms ease-in-out')),
      transition('false => true', animate('0ms ease-in-out')),
    ]),
  ],
  providers: [
    Location,
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
  ],
  host: {
    '(window:resize)': 'onWindowResize($event)',
  },
})
export class DashboardComponent implements OnInit {
  declare $: any;

  festivalThemeEnabled: boolean = true;
  visible: boolean = true;
  width = window.innerWidth;
  mobileWidth = 800;
  autoHideSideBar = 1100;
  o_id = '';
  borderActive1: string;
  borderActive2: string;
  borderActive3: string;
  borderActive4: string;
  borderActive5: string;
  borderActive6: string;
  borderActive7: string;
  navOn: boolean = false;
  navOn2: boolean = true;

  dashboardLanguages = {};
  dashboardLanguageCode = '';
  dashboardLanguage;
  selectedLanguageCode;

  public isCollapsed1 = true;
  public isCollapsed2 = true;
  public isCollapsed3 = true;
  public isCollapsed4 = true;
  public isCollapsed5 = true;
  public isCollapsed6 = true;
  public isCollapsed7 = true;

  public openNotification: boolean = false;

  notificationarray = [];
  notificationdata = [];
  notificationCount = 0;
  notificationCountShow = 0;
  notificationid = [];
  checkallhide: boolean = true;
  notificationlang: Object;
  mobileToggle: boolean = false;
  iconActive = [false, false, false];

  // Enable/disable Festival theme switch
  showFestivalTheme: boolean = false;

  fiv5s = environment.platformURL;
  dealer;
  dealerName = '';
  firstLetter = '';
  planName = '';

  dataEvent = {};

  isVisible: boolean = false;
  isVisibleBtmMenu: boolean = false;

  stores: any = [];
  featureList;
  storeId;
  dealerId;
  storeAmountLimit;
  token;
  defaultStore;
  storeListUpdated;
  storeAmount;
  status: string;
  statusClass: string;
  dealerStatus: string;
  isConvertedSuspended: boolean;
  referralStatus = false;
  dealer$ = this.dealerService.getDealer();
  storeList$ = this.storeInfoService.getStoreList();
  storeInfo$ = this.storeInfoService.getStoreInfo();
  estoreLogoPlatform;

  constructor(
    private svc: StoreService,
    public router: Router,
    private utils: UtilitiesService,
    public dataService: DataService,
    private translationSvc: TranslationService,
    private modalService: NgbModal,
    private dealerService: DealerService,
    private storeInfoService: StoreInfoService
  ) {
    // reset icon active on route change
    this.router.events.subscribe((routerEvent) => {
      this.iconActive = [false, false, false];
      if (routerEvent instanceof NavigationEnd) {
        this.openNavGroupFor(routerEvent.urlAfterRedirects);
      }
    });
  }

  private showGeneratedAiContentMessageOnce(storeInfo: any): void {
    const aiGeneratedStore = storeInfo?.ai_generated_store === true;
    const status = storeInfo?.generate_ai_content_status_summary?.status;
    const inProgress = status === 'QUEUE' || status === 'PROCESSING';
    let messageState = localStorage.getItem('generated_ai_content_message');

    if (aiGeneratedStore && messageState !== null && status === 'DONE') {
      this.utils.msgBox.open({
        title: this.utils.translate('AI Content Generation'),
        message: this.utils.translate(
          `<div class="flex justify-center mb-4">
             <img src="assets/feature-3.svg" alt="AI Content Completed" class="h-32 w-auto object-contain" />
           </div>
           <p class="mb-2"><b>Congratulations—your store content is ready!</b></p>
           <p>Your AI content generation has been completed successfully. You can now review and edit the generated content in your dashboard.</p>`,
        ),
        icon: 'success',
        buttonList: [
          { type: 'spacing' },
          {
            text: this.utils.translate('Great!'),
            style: 'primary',
            onClick: 'close',
          },
          { type: 'spacing' },
        ],
      });
      localStorage.removeItem('generated_ai_content_message');
      return;
    }

    if (!aiGeneratedStore || !inProgress) {
      return;
    }

    if (messageState === null) {
      localStorage.setItem('generated_ai_content_message', 'false');
      messageState = 'false';
    }

    if (messageState !== 'false') {
      return;
    }

    this.utils.msgBox.open({
      title: this.utils.translate('AI Content Generation'),
      message: this.utils.translate(
        `<div class="flex justify-center mb-4">
           <img src="assets/feature-3.svg" alt="AI Generating Content" class="h-32 w-auto object-contain" />
         </div>
         <p class="mb-2"><b>We are crafting your store's content!</b></p>
         <p class="mb-2">Our AI is currently working in the background to generate product descriptions, SEO tags, and more.</p>
         <p>You can continue exploring the dashboard—we will update the status automatically when it's ready.</p>`,
      ),
      icon: 'info',
      buttonList: [
        { type: 'spacing' },
        {
          text: this.utils.translate('Got it, thanks!'),
          style: 'primary',
          onClick: 'close',
        },
        { type: 'spacing' },
      ],
    });
    localStorage.setItem('generated_ai_content_message', 'true');
  }

  toggleFestivalTheme(e) {
    if (this.showFestivalTheme === false) {
      console.log('> No festival theme currently available...');
      return;
    }

    this.festivalThemeEnabled = !this.festivalThemeEnabled;
    console.log(`toggleFestivalTheme`, { e }, this.festivalThemeEnabled);

    if (this.festivalThemeEnabled) {
      // (window as any).$('body').addClass('theme--wc-2022');
    } else {
      // (window as any).$('body').removeClass('theme--wc-2022');
    }

    localStorage.setItem(
      'festivalTheme',
      this.festivalThemeEnabled?.toString()
    );
  }

  toggleOffAll() {
    for (let i = 0; i < 7; i++) {
      this['borderActive' + (i + 1)] = 'false';
      this['isCollapsed' + (i + 1)] = true;
    }
  }

  /**
   * The sidebar groups (their toggleOff index) and the routes under them. The
   * group of the current URL is opened and highlighted on load and after every
   * navigation, so the current page's item stays visible after a refresh and on
   * pages reached from inside a page (editing a landing page from the list).
   */
  private readonly navGroupRoutes: { group: number; routes: string[] }[] = [
    {
      group: 0,
      routes: [
        '/dashboard/orders',
        '/dashboard/order-subscription',
        '/dashboard/customers',
        '/dashboard/abandoned-carts',
      ],
    },
    {
      group: 2,
      routes: ['/dashboard/discounts', '/dashboard/email-template', '/dashboard/referral'],
    },
    {
      group: 3,
      routes: [
        '/dashboard/design',
        '/dashboard/pages',
        '/dashboard/page',
        '/dashboard/menu-manager',
        '/dashboard/domain',
        '/dashboard/gallery',
      ],
    },
    {
      group: 5,
      routes: [
        '/dashboard/revenue-lost-report',
        '/dashboard/landing-page-report',
        '/dashboard/express-checkout-dashboard',
      ],
    },
  ];

  /** Whether `url` is `route` or a page under it, by whole path segments. */
  private isUnderRoute(url: string, route: string): boolean {
    const path = (url || '').split(/[?#]/)[0];
    return path === route || path.startsWith(route + '/');
  }

  /** Landing Pages: the list, and creating or editing a page (/dashboard/page/...) */
  get isLandingPagesRoute(): boolean {
    return (
      this.isUnderRoute(this.router.url, '/dashboard/pages') ||
      this.isUnderRoute(this.router.url, '/dashboard/page')
    );
  }

  private openNavGroupFor(url: string) {
    const match = this.navGroupRoutes.find((navGroup) =>
      navGroup.routes.some((route) => this.isUnderRoute(url, route)),
    );
    if (!match) {
      return;
    }
    for (let i = 0; i < 7; i++) {
      this['borderActive' + (i + 1)] = i === match.group ? 'border-active' : 'false';
      this['isCollapsed' + (i + 1)] = i !== match.group;
    }
  }

  toggleOff(param: number) {
    if (this['borderActive' + (param + 1)] === 'border-active') {
      this.toggleOffAll();
    } else {
      for (let i = 0; i < 7; i++) {
        this['borderActive' + (i + 1)] =
          i === param ? 'border-active' : 'false';
        this['isCollapsed' + (i + 1)] = i !== param;
      }
    }
  }

  ngOnInit(): void {
    const isIframe = window.top !== window.self;

    if (isIframe) {
      setTimeout(() => {
        this.collapseMenu();
      }, 10);

      this.utils.turnDarkModeOn();
    }

    this.estoreLogoPlatform = this.extractValue(environment.storeSubdomain);
    this.openNavGroupFor(this.router.url);

    if (this.width <= this.mobileWidth) {
      this.visible = false;
      this.navOn = false;
      this.navOn2 = true;
    } else {
      this.visible = true;
      this.navOn2 = true;
      this.navOn = false;
    }

    this.token = localStorage.getItem('bearer');
    this.storeId = localStorage.getItem('store_id');
    this.dataService.storeId = this.storeId;
    this.defaultStore = localStorage.getItem('default_store');
    const info = JSON.parse(localStorage.getItem('5s-info'));
    this.dashboardLanguages = this.translationSvc.getAvailableLanguage();
    this.dashboardLanguageCode = this.translationSvc.getLanguageCode();
    this.dashboardLanguage = this.translationSvc.getCurrentLanguage();
    localStorage.setItem('dashboard-lang', this.dashboardLanguage.languageCode);
    this.dealerId = info.d_id;

    if (localStorage.getItem('festivalTheme') !== null) {
      this.festivalThemeEnabled = !!(
        localStorage.getItem('festivalTheme') === 'true'
      );
    }
    this.festivalThemeEnabled = !this.festivalThemeEnabled;

    // this.dealerService.fetchDealerInfo();
    // this.storeInfoService.fetchStoreInfo();
    this.storeInfoService.fetchStoreList();
    this.toggleFestivalTheme(null);
    this.getDealerInfo();
    this.getStoreList();

    this.storeInfo$.subscribe((storeInfo) => {
      this.showGeneratedAiContentMessageOnce(storeInfo);
    });

    this.checkDealerStatus();

    // Add event listners
    this.storeListUpdated = this.dataService
      .getStoreListUpdatedEvent()
      .subscribe((data) => this.handleStoreListUpdatedEvent(data));

    this.dataService.getLocalStorageData().subscribe();
    this.getReferralStatus();
  }

  handleStoreListUpdatedEvent(data) {
    this.stores = Array.isArray(data) ? data : Object.values(data || {});
    this.ensureActiveStore();
  }

  getStoreList() {
    this.storeList$.subscribe((res) => {
      this.stores = Object.values(res || {});
      this.dataService.emitStoreListUpdatedEvent(res);
      this.ensureActiveStore();
    });
  }

  ensureActiveStore() {
    if (!this.stores || this.stores.length === 0) {
      return;
    }

    const currentId = localStorage.getItem('store_id') || this.storeId || this.dataService.storeId;
    const defaultStoredId = localStorage.getItem('default_store') || this.defaultStore || this.dealer?.default_store;

    let matchedStore = this.stores.find((s) => currentId && +s?.store_id === +currentId);

    if (!matchedStore && defaultStoredId) {
      matchedStore = this.stores.find((s) => +s?.store_id === +defaultStoredId);
    }

    if (!matchedStore) {
      matchedStore = this.stores.find((s) => s?.status !== false) || this.stores[0];
    }

    if (matchedStore && matchedStore.store_id) {
      this.storeId = String(matchedStore.store_id);
      this.dataService.storeId = this.storeId;
      localStorage.setItem('store_id', this.storeId);
      if (matchedStore.store_name) {
        localStorage.setItem('store_name', matchedStore.store_name);
      }
      if (matchedStore.store_url || matchedStore.domain) {
        const url = matchedStore.store_url || (matchedStore.domain ? `https://${matchedStore.domain}` : null);
        if (url && !localStorage.getItem('store_url')) {
          localStorage.setItem('store_url', url);
        }
      }
    }
  }

  isStoreActive(storeId: any): boolean {
    const activeId = this.storeId || this.dataService.storeId || localStorage.getItem('store_id') || this.defaultStore;
    return !!storeId && !!activeId && +storeId === +activeId;
  }

  get allowCreateStore() {
    return (
      typeof this.featureList !== 'undefined' &&
      this.featureList.includes('multi-estore') &&
      this.storeAmountLimit > this.stores.length
    );
  }

  getDealerInfo(): void {
    this.dealer$.subscribe((res) => {
      this.dealer = res;
      this.dataService.updateDealerInfo(res);
      this.dataService.updateDealerPlan(res?.dealer_plan);
      this.dataService.updateDealerCredits(res?.dealer_credits);
      this.featureList = res?.dealer_plan?.feature_list;
      this.dealerName = res?.dealer_name;
      this.firstLetter = res?.dealer_name[0].toUpperCase();
      const planDesc = res?.dealer_plan?.plan_desc;
      this.planName = planDesc?.replace(' Plan', '').toUpperCase();
      this.storeAmountLimit = res?.dealer_plan?.store_number;
    });
  }

  changeLanguage(languageCode) {
    this.dashboardLanguageCode = languageCode;

    // Change Dashboard Language
    this.translationSvc.changeLanguage(languageCode);
    this.dashboardLanguage = this.translationSvc.getCurrentLanguage();
  }

  notification = function (res) {
    if (res['data'].length > 0) {
      res['data'].forEach((value, index) => {
        this.notificationdata[index] = [];
        this.notificationdata[index]['is_read'] = value.is_read;
        this.notificationdata[index]['id'] = value.id;
        this.notificationdata[index]['notification_content'] =
          value.notification_content;
        this.notificationlang =
          this.notificationdata[index]['notification_content']['en-US'][
          'title'
          ];
        this.notificationCount++;
        this.notificationCountShow++;
      });
    }

    if (this.notificationCount >= 5) {
      this.notificationCount = 5;
    }
  };

  createNotification() {
    return new Array(this.notificationCount);
  }

  showNav() {
    if (this.navOn2 == true && this.navOn == true) {
      this.visible = true;
    }
  }

  closeNav() {
    if (this.navOn2 == true && this.navOn == true) {
      this.navOn2 = true;
      this.visible = false;
    }
  }

  collapseMenu() {
    if (this.navOn2 == true && this.navOn == true) {
      this.navOn = false;
      this.navOn2 = true;
    } else {
      this.navOn = true;
      this.visible = !this.visible;
    }
  }

  collapseMenuMobile() {
    // this.visible = true;
    if (this.navOn2 === true) {
      document.querySelector<HTMLInputElement>(
        '.sidenav-expanded'
      ).style.transform = 'translate3d(0px, 0px, 0px) !important';
      this.visible = !this.visible;
      this.mobileToggle = !this.mobileToggle;
    }
    document.querySelector<HTMLInputElement>('.section-sidenav').style.display =
      'block';
  }

  onWindowResize(event: any) {
    this.width = event.target.innerWidth;

    if (this.width <= this.mobileWidth) {
      this.visible = false;
      this.navOn = false;
      this.navOn2 = true;
    } else {
      this.visible = true;
      this.navOn2 = true;
      this.navOn = false;
    }
  }

  onKey(event) {
    this.o_id = event.target.value;
  }

  getSearchOrderHistory() {
    let id = this.o_id;
    this.o_id = '';
    if (id == '') {
    } else {
      this.borderActive1 = 'border-active';
      this.isCollapsed1 = false;
      this.router.navigate(['/dashboard/orders', id]);
    }
  }

  toggleNotificationMobile() {
    this.openNotification = !this.openNotification;
  }

  viewStore() {
    let store_url = localStorage.getItem('store_url');
    if (store_url != null) {
      const base = store_url.replace(/\/+$/, '');

      // Opened inside the click itself, then pointed at the storefront once the
      // defaults below are known: a window.open issued after an HTTP response
      // has left the click's gesture, which is what a popup blocker stops.
      const tab = window.open('', '_blank');

      if (tab) {
        // The storefront has no business reaching back into the dashboard.
        tab.opener = null;
      }

      this.fetchStorefrontLocalePath()
        .catch(() => '')
        .then((path) => {
          const url = base + path;

          if (tab) {
            tab.location.href = url;
          } else {
            window.open(url, '_blank');
          }
        });
    } else {
      this.utils.notify.showWarning(
        this.utils.translate('Something went wrong! please contact support.'),
        this.utils.translate('Uh oh!')
      );
    }
  }

  goTo(link: string) {
    const segments = link.split('/');
    const navlevel = segments.length >= 2 ? segments[segments.length - 2] : '';
    const nav2 = segments[segments.length - 1];

    this.router.navigate([link]).then((success) => {
      const type = (success !== false) ? nav2 : 'Navigation Fail';
      const eventData: any = {
        data: {
          d_id: this.dealer?.['dealer_id'] ?? '',
          type,
          distinct_id: this.dealer?.['dealer_id'] ?? '',
          dealer_username: this.dealer?.['dealer_name'] ?? '',
          navlevel,
          nav2,
          redirect2: link,
          platform: 'dashboard',
        },
        application: 'dashboard',
        driver: 'mixpanel',
      };
      if (success === false) {
        eventData.data.error_response = 'Navigation cancelled';
      }
      this.publish_events(eventData);
    }).catch((err) => {
      this.publish_events({
        data: {
          d_id: this.dealer?.['dealer_id'] ?? '',
          type: 'Navigation Fail',
          distinct_id: this.dealer?.['dealer_id'] ?? '',
          dealer_username: this.dealer?.['dealer_name'] ?? '',
          navlevel,
          nav2,
          redirect2: link,
          platform: 'dashboard',
          error_response: err?.message ?? 'Navigation error',
        },
        application: 'dashboard',
        driver: 'mixpanel',
      });
    });
  }

  extractNav(input: string): string {
    const segments = input.split('/'); // Split the string by '/'
    return segments[segments.length - 1].toLowerCase(); // Return the last segment, which is 'setting'
  }

  gotoSetting() {
    this.router.navigate(['/dashboard/preferences'], {
      queryParams: { tab: 'Profile' },
    });
  }

  gotoStore() {
    this.router.navigate(['/dashboard/list-stores']);
  }

  logoutUser() {
    try {
      localStorage.removeItem('5s-info');
      localStorage.removeItem('store_id');
      localStorage.removeItem('store_url');
      localStorage.removeItem('bearer');
      localStorage.removeItem('store_name');
      localStorage.removeItem('default_store');
      localStorage.removeItem('feature');

      this.router.navigate(['/login']);
    } catch (e) {
      console.error('Unable to logout properly');
      console.error({ e });
    }
  }

  publish_events(data) {
    this.svc.publish_event(data).subscribe(
      (res) => {
        console.log({ res });
      },
      (error) => {
        console.log({ error });
      }
    );
  }

  toggleIcon(i: number) {
    this.iconActive = [false, false, false];
    setTimeout(() => {
      this.iconActive[i] = true;
    }, 100);
  }

  onClickDisplay() {
    this.isVisible = !this.isVisible;
  }

  onClickDisplayBtmMenu() {
    this.isVisibleBtmMenu = !this.isVisibleBtmMenu;
  }

  get currentStoreName(): string {
    const activeId = this.storeId || this.dataService.storeId || localStorage.getItem('store_id') || this.defaultStore;
    const currentStore = this.stores.find(store => activeId && +store?.store_id === +activeId);
    return currentStore ? currentStore.store_name : (localStorage.getItem('store_name') || 'Select Store');
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    // Close profile dropdown if clicked outside
    const profileDropdownEl = document.querySelector('.profile-nav');
    if (profileDropdownEl && target && !profileDropdownEl.contains(target)) {
      this.isVisible = false;
    }
  }

  showCreateStore() {
    if (this.storeAmountLimit <= 1) {
      this.utils.notify.showError(
        this.utils.translate(
          'Unable to create store. You have reached maximum store limit'
        )
      );
      return false;
    } else {
      this.modalService.open(DashboardCreateStoreComponent, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        backdrop: 'static',
        size: 'lg',
      });
    }
  }

  switchStore(storeId) {
    const storeData = this.getStoreDataByStoreId(storeId);
    if (storeData.status === false) {
      this.utils.notify.showWarning(this.utils.translate('Please Subscribe!'));
      return false;
    }

    if (storeId !== this.storeId) {
      const storeData = this.getStoreDataByStoreId(storeId);
      window.location.reload();
      this.utils.switchStore(
        storeId,
        storeData,
        false,
        'Updated selected store to "{0}" successfully.'
      );
    }
  }

  getStoreDataByStoreId(storeId) {
    return this.stores.find((store) => {
      return +store?.store_id === +storeId;
    });
  }

  get dealerWhitelistStatus() {
    let feature = localStorage.getItem('feature');
    if (
      feature !== undefined &&
      feature !== null &&
      feature !== '[]' &&
      feature !== ''
    ) {
      let features = feature.split(',');
      let check = features.find((t) => t === 'create-multi-estore');
      return check !== undefined && check !== null;
    } else {
      return false;
    }
  }

  checkDealerStatus() {
    let info = JSON.parse(localStorage.getItem('5s-info'));
    this.statusClass = DEALER_STATUS[info.status].class;
    this.dealerStatus = DEALER_STATUS[info.status].status;
    if (this.dealerStatus === 'Converted' || this.dealerStatus === 'Suspended') {
      this.isConvertedSuspended = true;
    }
  }

  toggleDarkMode() {
    this.utils.toggleDarkMode();
  }

  get currentYear() {
    return new Date().getFullYear();
  }

  public getReferralStatus(): void {
    this.svc.getReferralStatus(this.token).subscribe(
      (res) => {
        this.referralStatus = res['data']['status'];
      },
      (error) => {
        console.log({ error });
      }
    );
  }

  /**
   * The "/<country>/<language>" prefix the storefront serves under: the default
   * country and default language chosen in Preferences.
   *
   * Every storefront page lives below that prefix, so View Store opening the
   * bare root lands on an address no visitor is ever given. Read afresh on each
   * click rather than once per session: this shell is never rebuilt when
   * Preferences saves a new default, so a cached value kept opening the old
   * country until the whole dashboard was reloaded. Either default missing
   * resolves to '' and the root opens as before.
   */
  private fetchStorefrontLocalePath(): Promise<string> {
    const token = localStorage.getItem('bearer');
    const storeId = localStorage.getItem('store_id');

    return Promise.all([
      this.svc.getStoreCountry(token, storeId).toPromise(),
      this.svc.getStoreLanguage(token, storeId).toPromise(),
    ]).then(([countryRes, languageRes]: any[]) => {
      const countryCode = String(
        (countryRes?.data ?? []).find((row) => +row?.default === 1)
          ?.country_code ?? ''
      ).toLowerCase();
      const languageCode = String(
        (languageRes?.data ?? []).find((row) => +row?.default === 1)
          ?.language_code ?? ''
      ).toLowerCase();

      return countryCode && languageCode
        ? `/${countryCode}/${languageCode}`
        : '';
    });
  }

  private extractValue(url: string): string | null {
    const match = url.match(/(?:dev\.)?([a-zA-Z0-9_-]+)\.(?:com|dev)/);
    console.log('match checking ', match);
    if (match?.[1] === "globemerce") {
      return "estoreglobe";
    }
    return match?.[1] || null;
  }
}
